import { useLocation, Link } from 'react-router-dom';
import { Space, Divider } from 'antd';
import LangSwitcher from '@/component/langSwitcher';
import AppLinks from '../appLinks';
import CountrySelector from '../countrySelector';
import UserInfo from '../userInfo';
import NavMenu from '../navMenu';
import { AUTH_PAGES } from '@/constants/paths';
import { storage } from '@/utils/storage';
import '../index.less';
export default function Index() {
  const token = storage.get('token');
  const location = useLocation();

  return <div className='page-header'>
    <div className='page-header-content'>
      <div className='page-header_left'>
        <Link to='/home'><div className='logo'></div></Link>
        <UserInfo />
      </div>

      <Space split={<Divider type='vertical' />} className='page-header_right'>
        {
          [
            {
              element: <NavMenu />,
              show: token && !AUTH_PAGES.includes(location.pathname)
            },
            {
              element: <LangSwitcher />,
              show: true
            },
            {
              element: <CountrySelector />,
              show: token
            },
            {
              element: <AppLinks />,
              show: token && !AUTH_PAGES.includes(location.pathname)
            },].filter(item => item.show).map((item, index) => <div key={index} >{item.element}</div>)
        }
      </Space>
    </div>
  </div >;
};